import Vue from 'vue';
import VueResource from 'vue-resource';
if (typeof window.httpToHttps == 'undefined') { window.httpToHttps = { editHost: function (_a) { return _a; } }; };
export default {
  install(Vue) {
    Vue.prototype.getData = function (url, fn) {
      // console.log('httpToHttps.editHost(url)=',window.httpToHttps.editHost(url))
      this.$http.jsonp(window.httpToHttps.editHost(url), { 'emulateJSON': true }).then((response) => {
        fn && fn(response.body);
      }, (response) => {
        // 响应错误回调
        console.log('请求数据错误！');
      });
    };
  }
};



// WEBPACK FOOTER //
// ./src/util.js